import React, { useEffect, useState } from "react";
import mammoth from "mammoth";

const DocxFromS3Viewer = ({ signedUrl }) => {
  const [htmlContent, setHtmlContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!signedUrl) {
      setError("No signed URL provided.");
      setLoading(false);
      return;
    }

    const fetchAndConvertDocx = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch(signedUrl);
        if (!response.ok) {
          throw new Error(
            `Failed to fetch document. Status: ${response.status}`
          );
        }

        // Read the DOCX data as an ArrayBuffer
        const arrayBuffer = await response.arrayBuffer();

        // Convert the DOCX content to HTML using mammoth.js
        const { value: html } = await mammoth.convertToHtml({ arrayBuffer });
        setHtmlContent(html);
      } catch (e) {
        console.error("Error fetching or converting DOCX:", e);
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAndConvertDocx();
  }, [signedUrl]);

  if (loading) {
    return <div>Loading document...</div>;
  }

  if (error) {
    return <div>Summary currently not available.</div>;
    // return <div style={{ color: "red" }}>Error: {error}</div>;
  }

  return (
    <div className="docx-content-container">
      {/* 
        Warning: Use with caution. Only apply if the HTML source (in this case, 
        mammoth.js output from a trusted signed URL) is safe.
      */}
      <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
    </div>
  );
};

export default DocxFromS3Viewer;
